<ng-content />
<!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus, @angular-eslint/template/click-events-have-key-events -->
<dialog #dialog (click)="closeZoom(); $event.stopPropagation()">
  <kb-picture [picture]="picture" [variants]="originalVariants" [alt]="alt" [rootColumns]="12" />
</dialog>
